import { render, staticRenderFns } from "./senha.vue?vue&type=template&id=32aa5896"
import script from "./senha.vue?vue&type=script&lang=js"
export * from "./senha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports